import React from 'react';
import PropTypes from 'prop-types';


function BinWithCrossIcon({ width = 22, height = 28 }) {
    return (<svg width={ width } height={ height } viewBox="0 0 5.048 6.35">
        <path fill="currentColor" d="M.576 6.262a.683.683 0 01-.197-.22C.31 5.91.309 5.845.309 3.76V1.61h4.43v2.148c0 2.08-.002 2.151-.068 2.282a.709.709 0 01-.197.222l-.128.087-3.642-.004zm1.597-1.655c.172-.175.329-.318.348-.318.02 0 .217.18.438.4l.4.4.21-.199c.115-.11.209-.21.209-.222 0-.013-.17-.195-.378-.405-.208-.21-.378-.41-.378-.443 0-.034.174-.236.386-.449l.386-.387-.214-.214-.214-.214-.404.403c-.223.222-.416.403-.43.403s-.205-.177-.425-.393c-.315-.31-.412-.387-.456-.363-.031.016-.132.11-.223.208l-.166.177.4.401c.219.22.399.416.399.434 0 .018-.181.214-.402.436l-.402.403.426.426.09-.083c.048-.046.229-.226.4-.4zM0 .632V.34h1.55l.16-.156A.855.855 0 011.944.01c.04-.01.334-.013.653-.007l.58.01.331.327h1.541v.584H0z"/>
    </svg>);
}

BinWithCrossIcon.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
};

export default BinWithCrossIcon;



// WEBPACK FOOTER //
// ./src/components/icons/BinWithCrossIcon.js